import storageService from '../../services/storage/storageService';

export const AUTH_SET_AUTH_DATA = 'app/auth/AUTH_SET_AUTH_DATA';
export const AUTH_SET_SPICE_TOKEN = 'app/auth/AUTH_SET_SPICE_TOKEN';
export const AUTH_SET_UAM_TOKEN = 'app/auth/AUTH_SET_UAM_TOKEN';
export const AUTH_SET_GAM_TOKEN = 'app/auth/AUTH_SET_GAM_TOKEN';
export const AUTH_CLEAR_GAM_TOKEN = 'app/auth/AUTH_CLEAR_GAM_TOKEN';
export const FETCH_TOKEN_IN_PROGRESS = 'app/auth/FETCH_TOKEN_IN_PROGRESS';

const getInitialData = () => ({
    accessToken: storageService.getAccessTokenFromStorage(),
    expirationDate: storageService.getAccessTokenExpirationFromStorage(),
    refreshToken: storageService.getRefreshTokenFromStorage(),
    spiceToken: storageService.getSpiceTokenFromStorage(),
    username: storageService.getUsernameFromStorage(),
});

export default function reducer(state = getInitialData(), action) {
    switch (action.type) {
        case AUTH_SET_AUTH_DATA: {
            const {accessToken, refreshToken, expirationDate, isAnonymous, isRequestFailed} = action.payload;

            return {...state, accessToken, refreshToken, expirationDate, isAnonymous, isRequestFailed};
        }
        case AUTH_SET_SPICE_TOKEN: {
            const {spiceToken, username} = action;

            return {...state, spiceToken, username};
        }
        case AUTH_SET_UAM_TOKEN: {
            return {...state, ...action};
        }
        case AUTH_SET_GAM_TOKEN: {
            const {gamAuthToken, holderGamAuthToken} = action;

            if (gamAuthToken) {
                return {...state, gamAuthToken};
            }
            return {...state, holderGamAuthToken};
        }
        case AUTH_CLEAR_GAM_TOKEN: {
            const isHolder = action.payload;

            if (isHolder) {
                return {...state, holderGamAuthToken: undefined};
            }

            return {...state, gamAuthToken: undefined};
        }
        case FETCH_TOKEN_IN_PROGRESS: {
            return {...state, isFetchTokenInProgress: action.payload};
        }
        default:
            return state;
    }
}

export const setFetchTokenInProgress = (data) => ({type: FETCH_TOKEN_IN_PROGRESS, payload: data});

export const setAuthData = ({accessToken, refreshToken, expirationDate, isAnonymous, isRequestFailed}) => ({
    type: AUTH_SET_AUTH_DATA,
    payload: {accessToken, refreshToken, expirationDate, isAnonymous, isRequestFailed},
});

export const setSpiceData = (token, username) => ({
    type: AUTH_SET_SPICE_TOKEN,
    spiceToken: token,
    username,
});

export const removeSpiceData = () => ({
    type: AUTH_SET_SPICE_TOKEN,
    spiceToken: undefined,
    username: undefined,
});

export const clearUamAuthToken = (isHolder) => {
    const dic = {
        type: AUTH_SET_UAM_TOKEN,
    };

    if (isHolder) {
        dic.holderUamAuthToken = undefined;
    } else {
        dic.uamAuthToken = undefined;
    }

    return dic;
};

export const setUamData = ({authToken, identityKey, uamUrl, uamApiKey, isHolder}) => {
    const dic = {
        type: AUTH_SET_UAM_TOKEN,
        uamApiKey,
        uamApiUrl: uamUrl,
    };

    if (isHolder) {
        dic.holderUamAuthToken = authToken;
    } else {
        dic.uamAuthToken = authToken;
    }

    if (identityKey) {
        dic.uamIdentityKey = identityKey;
    }

    return dic;
};

export const setGamData = (isHolder, authToken) => {
    const data = {
        type: AUTH_SET_GAM_TOKEN,
    };

    if (isHolder) {
        data.holderGamAuthToken = authToken;
    } else {
        data.gamAuthToken = authToken;
    }

    return data;
};

export const removeGamAuthData = (isHolder = false) => ({type: AUTH_CLEAR_GAM_TOKEN, payload: isHolder});

export const removeAuthData = () => ({type: AUTH_SET_AUTH_DATA, payload: null});
